import { render } from "./preview-block.vue?vue&type=template&id=570afab6&scoped=true"
import script from "./preview-block.vue?vue&type=script&lang=js"
export * from "./preview-block.vue?vue&type=script&lang=js"

import "./preview-block.vue?vue&type=style&index=0&id=570afab6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570afab6"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBadge});
